import { type StateCreator } from 'zustand';

export type RunErrorEntry = {
  message: string;
  code?: string;
};

export type RunErrorSlice = {
  /** Run errors keyed by thread ID. */
  byThread: Record<string, RunErrorEntry | null>;
  /** Stores a run error for the given thread. */
  setRunError: (threadId: string, error: RunErrorEntry) => void;
  /** Clears any run error for the given thread. */
  clearRunError: (threadId: string) => void;
};

export type CreateRunErrorSlice = () => StateCreator<RunErrorSlice, [], [], RunErrorSlice>;

export const createRunErrorSlice: CreateRunErrorSlice = () => (set, get) => ({
  byThread: {},
  clearRunError: (threadId) => {
    const existing = get().byThread[threadId];

    if (!existing) {
      return;
    }

    set({
      byThread: {
        ...get().byThread,
        [threadId]: null,
      },
    });
  },
  setRunError: (threadId, error) => {
    set({
      byThread: {
        ...get().byThread,
        [threadId]: error,
      },
    });
  },
});
